import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Services = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="w-full bg-white text-black">
      {/* Seção de Introdução */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl font-bold">Nossos Serviços</h1>
          <p className="mt-4 text-lg text-gray-800">Conheça as principais áreas de atuação do nosso escritório de advocacia.</p>
        </div>
      </div>

      {/* Direito do Trabalho */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Direito do Trabalho</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto">
            <Slider {...settings}>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Reclamação Trabalhista</h3>
                <p className="text-gray-600 text-center mt-2">A reclamação trabalhista busca garantir os direitos do trabalhador quando há descumprimento da legislação. Isso inclui rescisões indevidas, pagamentos não realizados e outros problemas trabalhistas.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Defesa trabalhista para empresas</h3>
                <p className="text-gray-600 text-center mt-2">Nosso escritório oferece suporte jurídico para empresas, garantindo conformidade com a legislação e defesa em ações trabalhistas, reduzindo riscos e protegendo o patrimônio empresarial.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Consultoria trabalhista para R.H</h3>
                <p className="text-gray-600 text-center mt-2">Auxiliamos departamentos de recursos humanos com orientações estratégicas para evitar conflitos judiciais, garantindo que os contratos e políticas estejam dentro das normas legais.</p>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      {/* Direito Previdenciário */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Direito Previdenciário</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto">
            <Slider {...settings}>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Planejamento Previdenciário</h3>
                <p className="text-gray-600 text-center mt-2">Realizamos um estudo detalhado para garantir a melhor estratégia de aposentadoria, maximizando benefícios e reduzindo impactos tributários.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Revisão Previdenciária</h3>
                <p className="text-gray-600 text-center mt-2">A revisão previdenciária busca corrigir cálculos errados do INSS, garantindo que o segurado receba os valores corretos de aposentadoria e benefícios.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Aposentadoria</h3>
                <p className="text-gray-600 text-center mt-2">Auxiliamos no processo de solicitação de aposentadoria, garantindo que todas as documentações estejam corretas e agilizando o processo.</p>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      {/* Direito Civil e Direito do Consumidor */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Direito Civil e Direito do Consumidor</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto">
            <Slider {...settings}>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Ação de Danos Morais</h3>
                <p className="text-gray-600 text-center mt-2">Ingressamos com ações para garantir reparação por danos morais sofridos, seja por ofensa à honra, constrangimento indevido ou danos à imagem.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Ações contra golpe do Pix</h3>
                <p className="text-gray-600 text-center mt-2">Oferecemos suporte para recuperar valores perdidos em fraudes eletrônicas, buscando a responsabilização dos envolvidos.</p>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      {/* Direito de Família */}
      <div className="bg-[#FEEECE] text-black py-16 px-20 w-full text-left mt-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-semibold">Direito de Família</h2>
          <div className="bg-white p-12 rounded-lg shadow-lg mt-6 w-11/12 mx-auto">
            <Slider {...settings}>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Ações de divórcio</h3>
                <p className="text-gray-600 text-center mt-2">Cuidamos do processo de separação de forma estratégica e humanizada, garantindo a melhor solução para ambas as partes.</p>
              </div>
              <div>
                <h3 className="text-gray-800 text-lg text-center font-bold">Ações de guarda</h3>
                <p className="text-gray-600 text-center mt-2">Defendemos o melhor interesse da criança em disputas de guarda, buscando acordos que garantam estabilidade e bem-estar.</p>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;